module.exports = __webpack_public_path__ + "911ad86d50830b2cfffb19d4eb3d5ee1.svg";